module.exports = __webpack_public_path__ + "img/Full Salone.5586994e.png";